export const LastUpdated = '15 Mai 2026';
